import { apiSlice } from "../api/apiSlice";

export const tasksApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTasks: builder.query({
            query: (projects) => {
                return "/tasks"
            }
        }),
        getTask: builder.query({
            query: (id) => {
                return `/tasks/${id}`
            }
        }),
        addNewTask: builder.mutation({
            query: (data) => ({
                url: "/tasks",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const result = await queryFulfilled;
                dispatch(apiSlice.util.updateQueryData(
                    "getTasks",
                    undefined,
                    (draft) => {
                        draft.push(result.data);
                    }
                )
                );

            }
        }),
        updateTask: builder.mutation({
            query: (data) => ({
                url: `/tasks/${data.id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const result = await queryFulfilled;
                dispatch(apiSlice.util.updateQueryData(
                    "getTasks",
                    undefined,
                    (draft) => {
                        const draftData = draft.find(single => single.id == arg.id)

                        draftData.taskName = result.data.taskName;
                        draftData.deadline = result.data.deadline;
                        draftData.teamMember = result.data.teamMember;
                        draftData.project = result.data.project;
                        draftData.status = result.data.status;
                    }
                )
                );
                // single
                dispatch(apiSlice.util.updateQueryData(
                    "getTask",
                    arg.id.toString(),
                    (draft) => {
                        // const draftData = draft.find(single => single.id == arg.id)
                        // draftData.status = result.data.status;
                        draft.taskName = result.data.taskName;
                        draft.deadline = result.data.deadline;
                        draft.teamMember = result.data.teamMember;
                        draft.project = result.data.project;
                        draft.status = result.data.status;
                        // return draft
                    }
                )
                );

            }

        }),
        deleteTask: builder.mutation({
            query: (data) => ({
                url: `/tasks/${data.id}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {

                // optimistic cache update start
                const pathResult = dispatch(
                    apiSlice.util.updateQueryData(
                        "getTasks",
                        undefined,
                        (draft) => {
                            const index = draft?.findIndex(single => single.id == arg?.id?.toString())
                            console.log({ index });

                            if (index !== -1) draft.splice(index, 1)



                        }
                    )
                );
                // optimistic cache update end
                try {
                    const result = await queryFulfilled;
                } catch (err) {
                    pathResult.undo()
                }


            }
        })

    })
})
export const { useGetTasksQuery, useGetTaskQuery, useAddNewTaskMutation, useUpdateTaskMutation, useDeleteTaskMutation } = tasksApi